import {
  useTableColumn,
  useSelectColumn,
  BaseTag,
  BaseToolTip
} from 'xrk-components';
import { AI_AUDIT_RESULT } from '@/common/constants/intelligent-audit';

export const aiResultSearch = useSelectColumn({
  prop: 'aiAuditStatus',
  label: '智能辅助审核结果',
  config: {
    options: AI_AUDIT_RESULT
  }
});

/** 风险点（每行单独省略，超出才显示 BaseToolTip） */
export const taskRiskPointsCol = useTableColumn({
  label: '风险点',
  prop: 'riskPoints',
  showOverflowTooltip: false,
  minWidth: 200,
  render: ({ row }: { row: any }) => {
    const points: string[] = row.riskPoints || [];
    if (!points.length) return <span>—</span>;
    return (
      <div>
        {points.map((label, i) => (
          <BaseToolTip key={i} placement="top" overShow content={label}>
            <div style="font-size:12px;line-height:1.8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:default">
              {label}
            </div>
          </BaseToolTip>
        ))}
      </div>
    );
  }
});

/** 智能辅助审核结果（彩色 tag） */
export const aiResultCol = useTableColumn({
  label: '智能辅助审核结果',
  prop: 'aiAuditStatus',
  width: 150,
  render: ({ row }: { row: any }) => {
    const item =
      AI_AUDIT_RESULT[row.aiAuditStatus as keyof typeof AI_AUDIT_RESULT];
    if (!item) return <span>—</span>;
    return (
      <BaseTag type={item.tagType as any} size="small">
        {item.label}
      </BaseTag>
    );
  }
});
